
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/cookie-policy",
      function () {
        return require("private-next-pages/info/cookie-policy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/cookie-policy"])
      });
    }
  